<template>
  <div>
    <!-- dialog -->
    <van-dialog v-model="showEx3Dialog" :show-cancel-button="false">
      <div
        style="
          display: flex;
          justify-content: space-around;
          align-items: center;
        "
      >
        <div style="text-align: center">
          <img src="../../../src/assets/images/aliex2.jpg" style="width: 90%" />
          <!-- <p>第一張</p> -->
        </div>
        <div style="text-align: center">
          <img src="../../../src/assets/images/aliEx.jpg" style="width: 90%" />
        </div>
      </div>
    </van-dialog>
    <van-dialog v-model="showExDialog" :show-cancel-button="false">
      <div
        style="
          display: flex;
          justify-content: space-around;
          align-items: center;
        "
      >
        <!-- <div style="text-align: center">
          <img src="../../../src/assets/images/aliex2.jpg" style="width: 90%" />
          <p>第一張</p>
        </div> -->
        <div style="text-align: center">
          <img src="../../../src/assets/images/aliEx.jpg" style="width: 90%" />
        </div>
      </div>
    </van-dialog>
    <van-dialog v-model="showEx2Dialog" :show-cancel-button="false">
      <div
        style="
          display: flex;
          justify-content: space-around;
          align-items: center;
        "
      >
        <div style="text-align: center">
          <img src="../../../src/assets/images/aliex3.jpg" style="width: 90%" />
        </div>
      </div>
    </van-dialog>

    <van-dialog
      :before-close="addMchBefore"
      v-model="alipayMchDialog"
      title="提交审核"
      show-cancel-button
    >
      <van-form>
        <van-field name="uploader" label="文件上传" required>
          <template #label>
            <p>文件上传</p>
            <p @click="showEx3Dialog = true" style="color: red">查看范例</p>
          </template>
          <template #input>
            <canvas id="canvas" style="display: none"></canvas>
            <van-uploader
              :before-read="beforeUploadMch"
              multiple
              accept="image/*,video/*"
              v-model="filesMch"
              :max-count="6"
              :before-delete="deleteImgList"
            />
          </template>
        </van-field>
      </van-form>
    </van-dialog>
    <van-popup v-model="bankSelect" position="bottom">
      <van-picker
        show-toolbar
        :columns="banks"
        @confirm="onConfirm"
        @cancel="bankSelect = false"
      />
    </van-popup>
    <van-dialog
      :before-close="delBankBefore"
      v-model="delBankModal"
      title="删除"
      show-cancel-button
    >
      <p style="text-align: center; color: red; padding: 15px">确认删除</p>
      <p style="text-align: center; padding: 15px; padding-top: 0px">
        {{ currentData.bank_no }} - {{ currentData.bank_name }}
      </p>
    </van-dialog>
    <van-dialog
      :before-close="editBankBefore"
      v-model="editBankModal"
      title="编辑"
      show-cancel-button
    >
      <van-form refs>
        <van-field
          v-model="currentData.bank_no"
          name="银行卡号"
          label="银行卡号"
          placeholder="银行卡号"
          disabled
          :rules="[{ required: true, message: '请填写银行卡号' }]"
        />
        <van-field
          v-model="currentData.bank_name"
          name="开户银行"
          label="开户银行"
          placeholder="开户银行"
          disabled
          :rules="[{ required: true, message: '请填写银行卡号' }]"
        />
        <van-field
          v-model="currentData.bank_branch"
          name="支行名称"
          label="支行名称"
          placeholder="支行名称"
          disabled
          :rules="[{ required: true, message: '请填写支行名称' }]"
        />
        <van-field
          v-model="currentData.bank_owner"
          name="姓名"
          label="姓名"
          disabled
          placeholder="姓名"
          :rules="[{ required: true, message: '请填写姓名' }]"
        />
        <van-field
          v-model="currentData.ds_limit"
          name="每日限额"
          label="每日限额"
          placeholder="每日限额"
          type="number"
          :rules="[{ required: true, message: '请填写每日限额' }]"
        />
      </van-form>
    </van-dialog>
    <van-dialog
      :before-close="addDouyinBankBefore"
      v-model="addDouyinModal"
      title="新增抖音红包收款账户"
      show-cancel-button
    >
      <van-form ref="addBankPForm">
        <van-field
          v-model="addBankData.bank_no"
          name="抖音号(UID)"
          label="抖音号"
          placeholder="抖音号(UID)"
          required
          :rules="[{ required: true, message: '抖音号(UID)' }]"
        />
        <van-field
          v-model="addBankData.bank_owner"
          name="抖音昵称"
          label="抖音昵称"
          placeholder="抖音昵称"
          required
          :rules="[{ required: true, message: '请填写抖音昵称' }]"
        />
        <van-field
          v-model="addBankData.ds_limit"
          name="每日限额"
          label="每日限额"
          required
          placeholder="每日限额"
          type="number"
          :rules="[{ required: true, message: '请填写每日限额' }]"
        />
        <van-field required name="uploader" label="抖音号二维码">
          <template #input>
            <van-uploader
              :before-read="beforeUpload"
              multiple
              accept="image/*,video/*"
              v-model="files"
              :max-count="6"
            />
          </template>
        </van-field>
        <van-field
          required
          v-model="addBankData.oneCode"
          name="谷歌验证码"
          label="谷歌验证码"
          placeholder="谷歌验证码"
          v-if="$store.state.selfData.enable_2fa == 1"
        />
      </van-form>
    </van-dialog>
    <van-dialog
      :before-close="addDigitalyBefore"
      v-model="addDigitalyModal"
      title="新增数字人民币收款账户"
      show-cancel-button
    >
      <van-form ref="addBankPForm">
        <van-field
          v-model="addBankData.bank_no"
          name="钱包编号"
          label="钱包编号"
          placeholder="钱包编号"
          required
          :rules="[{ required: true, message: '请填写钱包编号' }]"
        />
        <van-field
          v-model="addBankData.bank_owner"
          name="姓名"
          label="姓名"
          placeholder="姓名"
          required
          :rules="[{ required: true, message: '请填写姓名' }]"
        />
        <van-field
          v-model="addBankData.ds_limit"
          name="每日限额"
          label="每日限额"
          required
          placeholder="每日限额"
          type="number"
          :rules="[{ required: true, message: '请填写每日限额' }]"
        />
        <van-field
          required
          v-model="addBankData.oneCode"
          name="谷歌验证码"
          label="谷歌验证码"
          placeholder="谷歌验证码"
          v-if="$store.state.selfData.enable_2fa == 1"
        />
      </van-form>
    </van-dialog>
    <van-dialog
      :before-close="addAlipayBankBefore"
      v-model="addAlipayModal"
      title="新增支付宝收款账户"
      show-cancel-button
    >
      <van-form ref="addBankPForm">
        <van-field
          v-model="addBankData.bank_no"
          name="收款账号"
          label="收款账号"
          placeholder="收款账号"
          required
          :rules="[{ required: true, message: '请填写账号' }]"
        />
        <van-field
          v-model="addBankData.bank_owner"
          name="昵称"
          label="昵称"
          placeholder="昵称"
          required
          :rules="[{ required: true, message: '请填写昵称' }]"
        />
        <van-field
          v-model="addBankData.bank_branch"
          name="真实姓名"
          label="真实姓名"
          placeholder="真实姓名"
          required
          :rules="[{ required: true, message: '请填写真实姓名' }]"
        />
        <van-field
          v-model="addBankData.ds_limit"
          name="每日限额"
          label="每日限额"
          required
          placeholder="每日限额"
          type="number"
          :rules="[{ required: true, message: '请填写每日限额' }]"
        />

        <van-field
          v-if="showAliLogin()"
          v-model="addBankData.alipay_userid"
          name="支付宝UID"
          label="支付宝UID"
          placeholder="支付宝UID"
          @input="
            addBankData.alipay_userid = addBankData.alipay_userid.replace(
              /\s+/g,
              ''
            )
          "
          type="number"
          :rules="[{ required: true, message: '请填写支付宝UID' }]"
        />
        <van-field label="获取支付宝UID" v-if="showAliLogin()">
          <template #input>
            <!-- <van-button
              size="normal"
              v-if="isMobile()"
              color="linear-gradient(to right, #ff6034, #ee0a24)"
              style="height: 35px"
              @click="getUID"
            >
              点击获取UID
            </van-button> -->

            <vue-qrcode
              margin="0"
              width="150"
              value="alipays://platformapi/startapp?appId=20000067&url=https%3A%2F%2Frender.alipay.com%2Fp%2Ff%2Ffd-ixpo7iia%2Findex.html"
            />
          </template>
        </van-field>

        <van-field
          required
          name="uploader"
          label="二维码"
          v-if="!($store.state.selfData.m_id == 155586)"
        >
          <template #input>
            <van-uploader accept="image/*" v-model="files" :max-count="1" />
          </template>
        </van-field>
        <van-field
          required
          v-model="addBankData.oneCode"
          name="谷歌验证码"
          label="谷歌验证码"
          placeholder="谷歌验证码"
          v-if="$store.state.selfData.enable_2fa == 1"
        />
      </van-form>
    </van-dialog>
    <van-dialog
      :before-close="addBankBefore"
      v-model="addBankModal"
      title="新增账户"
      show-cancel-button
    >
      <van-form ref="addBankPForm">
        <multiselect
          v-model="addBankData.bank_name"
          placeholder="选择开户银行"
          :options="banks"
          tagPlaceholder=""
          selectLabel=""
          deselectLabel=""
        >
          <span slot="noResult"> 查无银行 </span>
        </multiselect>
        <van-field
          v-if="addBankData.bank_name != '微信'"
          v-model="addBankData.bank_no"
          :name="returnName(addBankData.bank_name)"
          :label="returnName(addBankData.bank_name)"
          :placeholder="returnName(addBankData.bank_name)"
          required
          :rules="[
            {
              required: true,
            },
          ]"
        />
        <!-- 支付宝 -->
        <van-field
          v-if="addBankData.bank_name != '数字人民币'"
          v-model="addBankData.bank_branch"
          :name="
            addBankData.bank_name?.indexOf('支付宝') != -1 ||
            addBankData.bank_name == '微信'
              ? '真实姓名'
              : '支行名称'
          "
          :label="
            addBankData.bank_name?.indexOf('支付宝') != -1 ||
            addBankData.bank_name == '微信'
              ? '真实姓名'
              : '支行名称'
          "
          :placeholder="
            addBankData.bank_name?.indexOf('支付宝') != -1 ||
            addBankData.bank_name == '微信'
              ? '真实姓名'
              : '支行名称'
          "
          required
          :rules="[
            {
              required: true,
            },
          ]"
        />
        <van-field
          v-model="addBankData.bank_owner"
          :name="
            addBankData.bank_name?.indexOf('支付宝') != -1 ||
            addBankData.bank_name == '微信'
              ? '昵称'
              : '姓名'
          "
          :label="
            addBankData.bank_name?.indexOf('支付宝') != -1 ||
            addBankData.bank_name == '微信'
              ? '昵称'
              : '姓名'
          "
          :placeholder="
            addBankData.bank_name?.indexOf('支付宝') != -1 ||
            addBankData.bank_name == '微信'
              ? '昵称'
              : '姓名'
          "
          required
          :rules="[{ required: true }]"
        />

        <van-field
          v-if="
            addBankData.bank_name == '微信' &&
            ($store.state.selfData.m_id == 60002 ||
              $store.state.selfData.m_id == 85815 ||
              $store.state.selfData.m_id == 60007)
          "
          v-model="addBankData.alipay_userid"
          name="手机号"
          label="手机号"
          required
          placeholder="手机号(与二维码相同)"
          type="phone"
          :rules="[{ required: true }]"
        />
        <p
          v-if="
            addBankData.bank_name == '微信' &&
            ($store.state.selfData.m_id == 60002 ||
              $store.state.selfData.m_id == 85815 ||
              $store.state.selfData.m_id == 60007)
          "
          style="
            color: red;
            font-size: 14px;
            padding-left: 15px;
            padding-top: 2px;
          "
        >
          必须与二维码相同收款的手机号
        </p>
        <p
          v-if="
            addBankData.bank_name == '微信' &&
            ($store.state.selfData.m_id == 60002 ||
              $store.state.selfData.m_id == 85815 ||
              $store.state.selfData.m_id == 60007)
          "
          style="
            color: red;
            font-size: 14px;
            padding-left: 15px;
            padding-top: 2px;
          "
        >
          若输入错误无收到款，损失自负！
        </p>
        <van-field
          v-model="addBankData.ds_limit"
          name="每日限额"
          label="每日限额"
          required
          placeholder="每日限额"
          type="number"
          :rules="[{ required: true }]"
        />
        <van-field
          v-if="showAliLogin()"
          v-model="addBankData.alipay_userid"
          name="支付宝UID"
          label="支付宝UID"
          placeholder="支付宝UID"
          @input="
            addBankData.alipay_userid = addBankData.alipay_userid.replace(
              /\s+/g,
              ''
            )
          "
          type="number"
          :rules="[{ required: true, message: '请填写支付宝UID' }]"
        />

        <van-field label="获取支付宝UID" v-if="showAliLogin()">
          <template #input>
            <!-- <van-button
              size="normal"
              v-if="isMobile()"
              color="linear-gradient(to right, #ff6034, #ee0a24)"
              style="height: 35px"
              @click="getUID"
            >
              点击获取UID
            </van-button> -->

            <vue-qrcode
              margin="0"
              width="150"
              value="alipays://platformapi/startapp?appId=20000067&url=https%3A%2F%2Frender.alipay.com%2Fp%2Ff%2Ffd-ixpo7iia%2Findex.html"
            />
          </template>
        </van-field>

        <van-field
          v-if="
            addBankData.bank_name && !($store.state.selfData.m_id == 155586)
          "
          name="uploader"
          :required="
            addBankData.bank_name?.indexOf('支付宝') != -1 ||
            addBankData.bank_name == '微信'
          "
        >
          <template #label>
            <p>
              {{
                addBankData.bank_name?.indexOf("支付宝") != -1 ||
                addBankData.bank_name == "微信"
                  ? "二维码"
                  : "文件上传"
              }}
            </p>
            <p
              v-if="addBankData.bank_name == '支付宝经营码'"
              @click="showExDialog = true"
              style="color: red"
            >
              查看范例
            </p>
            <p
              v-if="addBankData.bank_name == '支付宝'"
              @click="showEx2Dialog = true"
              style="color: red"
            >
              查看范例
            </p>
          </template>
          <template #input>
            <!-- beforeUpload -->
            <canvas id="canvas" style="display: none"></canvas>
            <van-uploader
              @delete="
                addBankData.bank_name == '微信'
                  ? (addBankData.bank_no = '')
                  : ''
              "
              :before-read="
                addBankData.bank_name == '微信' ||
                addBankData.bank_name == '支付宝'
                  ? beforeUploadAli
                  : beforeUpload
              "
              :multiple="
                !(
                  addBankData.bank_name == '微信' ||
                  addBankData.bank_name == '支付宝'
                )
              "
              accept="image/*,video/*"
              v-model="files"
              :max-count="
                addBankData.bank_name == '微信' ||
                addBankData.bank_name == '支付宝'
                  ? 1
                  : 6
              "
            />
          </template>
        </van-field>
        <van-field
          required
          v-model="addBankData.oneCode"
          name="谷歌验证码"
          label="谷歌验证码"
          placeholder="谷歌验证码"
          v-if="$store.state.selfData.enable_2fa == 1"
        />
      </van-form>
    </van-dialog>
    <!-- dialog -->
    <!-- top -->
    <van-sticky>
      <van-nav-bar @click-left="onClickLeft" title="收款账户" left-arrow>
        <template #left>
          <van-icon name="arrow-left" />
        </template>
        <template #right>
          <div
            :style="{ color: $returnColor().color3 }"
            class="addAcc"
            @click="addBank"
          >
            <van-icon class="plus" name="plus" />新增
          </div>
        </template>
      </van-nav-bar>
    </van-sticky>
    <!-- top -->
    <div
      class="wrap"
      :style="{
        backgroundImage:
          'url(' +
          $returnColor().path +
          ($store.state.selfData.member_id
            ? '/home-page_bg.png'
            : '/home-page_bg.png') +
          ')',
      }"
    >
      <div
        v-if="$store.state.selfData.is_alipay == 4"
        style="
          display: flex;
          margin-bottom: 10px;
          justify-content: flex-start;
          width: 355px;
        "
      >
        <van-button
          size="normal"
          color="linear-gradient(to right, #ff6034, #ee0a24)"
          @click="addDigital"
        >
          新增收款-数字人民币
        </van-button>
        <van-button
          size="normal"
          color="linear-gradient(to right, #ff6034, #ee0a24)"
          style="margin-left: 5px"
          @click="addPay"
        >
          新增付款-银行卡
        </van-button>
      </div>
      <div
        v-if="$store.state.selfData.is_alipay == 1"
        style="
          display: flex;
          margin-bottom: 10px;
          justify-content: flex-start;
          width: 355px;
        "
      >
        <van-button
          size="normal"
          color="linear-gradient(to right, #ff6034, #ee0a24)"
          @click="addAlipay"
        >
          新增收款-支付宝
        </van-button>
        <van-button
          size="normal"
          color="linear-gradient(to right, #ff6034, #ee0a24)"
          style="margin-left: 5px"
          @click="addPay"
        >
          新增付款-银行卡
        </van-button>
      </div>
      <div
        v-if="$store.state.selfData.is_alipay == 2"
        style="
          display: flex;
          margin-bottom: 10px;
          justify-content: flex-start;
          width: 355px;
        "
      >
        <van-button
          size="normal"
          color="linear-gradient(to right, #ff6034, #ee0a24)"
          @click="addDouyin"
        >
          新增收款-抖音红包
        </van-button>
        <van-button
          size="normal"
          color="linear-gradient(to right, #ff6034, #ee0a24)"
          style="margin-left: 5px"
          @click="addPay"
        >
          新增付款-银行卡
        </van-button>
      </div>
      <div class="tableWrap" v-for="list in bankList" :key="list.id">
        <p class="tableContent">
          <span class="tableTitle">
            {{ returnBankNameTitle(list.bank_name) }}
          </span>
          <span class="tablesContent">
            {{ list.bank_no }}
          </span>
        </p>
        <p class="tableContent">
          <span class="tableTitle"> 开户银行 </span>
          <span class="tablesContent">
            {{ list.bank_name }}
          </span>
        </p>
        <p
          class="tableContent"
          v-if="list.bank_name != '抖音红包' && list.bank_name != '数字人民币'"
        >
          <span class="tableTitle">
            {{
              list.bank_name.indexOf("支付宝") == -1 && list.bank_name != "微信"
                ? "支行名称"
                : "真实姓名"
            }}
          </span>
          <span class="tablesContent">
            {{ list.bank_branch }}
          </span>
        </p>
        <p class="tableContent">
          <span class="tableTitle">
            {{
              list.bank_name.indexOf("支付宝") == -1 && list.bank_name != "微信"
                ? "姓名"
                : "昵称"
            }}
          </span>
          <span class="tablesContent">
            {{ list.bank_owner }}
          </span>
        </p>
        <p
          class="tableContent"
          v-if="
            list.bank_name == '微信' &&
            ($store.state.selfData.m_id == 85815 ||
              $store.state.selfData.m_id == 60007)
          "
        >
          <span class="tableTitle"> 手机号 </span>
          <span class="tablesContent">
            {{ list.alipay_userid }}
          </span>
        </p>
        <p class="tableContent">
          <span class="tableTitle"> 异常 </span>
          <span class="tablesContent">
            {{ list.aberrant == 0 ? "正常" : "异常" }}
          </span>
        </p>
        <p class="tableContent">
          <span class="tableTitle"> 每日限额 </span>
          <span class="tablesContent">
            {{ list.ds_limit || "未设置" }}
          </span>
        </p>
        <p class="tableContent">
          <span class="tableTitle"> 今日收款 </span>
          <span class="tablesContent">
            {{ list.trans_amount }}
          </span>
        </p>
        <p class="tableContent">
          <span class="tableTitle"> 启用状态 </span>
          <span class="tablesContent">
            <van-switch
              v-if="list.enable != 2"
              size="24"
              :active-color="$returnColor().color3"
              inactive-color="#cccccc"
              :value="list.enable == 1"
              @input="changeEnable(list)"
            />
            <span v-else style="color: red">待审核</span>
          </span>
        </p>
        <p class="tableContent">
          <span class="tableTitle"> 维护时段 </span>
          <span
            class="tablesContent"
            v-if="list.bank && list.bank.start && list.bank.end"
          >
            {{ list.bank.start }} ~ {{ list.bank.end }}
          </span>
          <span class="tablesContent" v-else> 无 </span>
        </p>
        <p class="tableContent">
          <span class="tableTitle"> 收款卡 </span>
          <span class="tablesContent">
            <van-switch
              size="24"
              :active-color="$returnColor().color3"
              inactive-color="#cccccc"
              :value="list.is_collection == 1"
              @input="changeIsC(list)"
            />
          </span>
        </p>
        <p class="tableContent">
          <span class="tableTitle"> 出款卡 </span>
          <span class="tablesContent">
            <van-switch
              size="24"
              :active-color="$returnColor().color3"
              inactive-color="#cccccc"
              :value="list.is_pay == 1"
              @input="changeIspay(list)"
            />
          </span>
        </p>
        <p
          class="tableContent"
          v-if="
            ($store.state.selfData.m_id == 60007 ||
              $store.state.selfData.m_id == 60002) &&
            list.bank_name == '支付宝'
          "
        >
          <span class="tableTitle"> 绑定 </span>
          <span class="tablesContent">
            {{ list.alipay_userid ? "已绑定" : "未绑定" }}
          </span>
        </p>
        <p class="tableContent" v-if="reutrnShowAddMch(list)">
          <span class="tableTitle"> 经营码 </span>
          <span class="tablesContent">
            <p v-if="list.is_alipay_mch == 1">申请通过</p>
            <van-button
              size="normal"
              v-else
              color="linear-gradient(to right, #ff6034, #ee0a24)"
              style="height: 35px"
              @click="alipayMch(list)"
            >
              提交审核
            </van-button>
          </span>
        </p>
        <div class="editBtn">
          <p
            @click="editBank(list)"
            :style="{
              color: $returnColor().color3,
              width:
                ($store.state.selfData.m_id &&
                  $store.state.selfData.m_id === 60007) ||
                $store.state.selfData.m_id === 116770 ||
                $store.state.selfData.m_id === 61929
                  ? '100%'
                  : '50%',
            }"
          >
            编辑银行卡
          </p>
          <p
            style="color: red"
            v-if="
              $store.state.selfData.m_id &&
              $store.state.selfData.m_id != 60007 &&
              $store.state.selfData.m_id != 116770 &&
              $store.state.selfData.m_id != 61929
            "
            @click="delBank(list)"
          >
            删除银行卡
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { Toast } from "vant";
import Multiselect from "vue-multiselect";
import QrCode from "qrcode-reader";
import * as imageConversion from "image-conversion";
import VueQrcode from "vue-qrcode";
import jsQR from "jsqr";
import { BrowserQRCodeReader } from "@zxing/browser";

export default {
  components: { Multiselect, VueQrcode },
  data() {
    return {
      bankSelect: false,
      show: true,
      newPassword: "",
      password: "",
      paginate: {},
      bankList: [],
      addBankModal: false,
      editBankModal: false,
      addBankData: { type: 0, bank_no: "" },
      currentPage: 1,
      currentData: {},
      banks: [],
      files: [],
      delBankModal: false,
      open: false,
      next_page: true,
      wait: false,
      addAlipayModal: false,
      addDouyinModal: false,
      addDigitalyModal: false,
      getCT: "",
      currentAliBankNo: "",
      currentAliBankB: "",
      isAliQrcode: false,
      alipayMchDialog: false,
      isHttps: window.location.protocol === "https:",
      httpFiles: [],
      filesMch: [],
      showExDialog: false,
      showEx2Dialog: false,
      showEx3Dialog: false,
    };
  },
  watch: {
    // currentPage() {
    // this.getBank();
    // },
  },
  methods: {
    getUploadRawFile(item) {
      if (!item) return null;
      return item.file || item;
    },

    addMchBefore(method, done) {
      let vm = this;
      // let formData = new FormData();
      if (method == "confirm") {
        //   if (!this.isHttps) {
        //     this.httpFiles.forEach((e) => {
        //       formData.append("images[]", e);
        //     });
        //     // formData.append("byPath", 1);
        //   } else {
        //     this.errorFiles.forEach((file) => {
        //       formData.append("upload_file[]", file.file);
        //     });
        //   }

        vm.$http
          .post(`/mobile/bankCard/${vm.currentData.id}/alipayMch`, {
            images: this.httpFiles,
          })
          .then((res) => {
            if (res.data.code == 0) {
              Toast.success("申请成功");
              done();
            } else {
              done(false);
            }
          });
      } else {
        done();
      }
    },

    beforeUploadMch(files) {
      this.$store.dispatch("setLoadding", true);

      let allFile = Array.isArray(files) ? files : [files];

      let imgListPromise = Promise.all(
        allFile.map((file) => {
          if (file.type.indexOf("video") !== -1) {
            return Promise.resolve(file);
          }

          return imageConversion
            .compressAccurately(file, 1000)
            .then((res) => res)
            .catch(() => file);
        })
      )
        .then((results) => {
          if (!this.isHttps) {
            const uploadPromises = results.map((file) => {
              const formData = new FormData();
              formData.append("image", file);

              return this.$http
                .post("/doupload", formData)
                .then((res) => {
                  const success = res?.data?.success;
                  if (success === true) {
                    this.httpFiles.push(res.data.url);
                    return file;
                  } else {
                    alert(JSON.stringify(res, null, 2));
                    this.$toast.fail("上传失败 请再试一次");
                    return null;
                  }
                })
                .catch((err) => {
                  alert(JSON.stringify(err, null, 2));
                  console.error("上传错误", err, file);
                  return null;
                });
            });

            return Promise.all(uploadPromises).then((filteredResults) => {
              const successfulFiles = filteredResults.filter((f) => f !== null);
              this.$store.dispatch("setLoadding", false);
              return successfulFiles;
            });
          } else {
            const uploadPromises = results.map((file) => {
              const formData = new FormData();
              formData.append("upload_file", file);

              return this.$http
                .post("/mobile/upload", formData)
                .then((res) => {
                  const success = res?.data?.code;
                  if (success === 0) {
                    this.httpFiles.push(res.data.data);
                    return file;
                  } else {
                    alert(JSON.stringify(res, null, 2));
                    this.$toast.fail("上传失败 请再试一次");
                    return null;
                  }
                })
                .catch((err) => {
                  alert(JSON.stringify(err, null, 2));
                  console.error("上传错误", err, file);
                  return null;
                });
            });

            return Promise.all(uploadPromises).then((filteredResults) => {
              const successfulFiles = filteredResults.filter((f) => f !== null);
              this.$store.dispatch("setLoadding", false);
              return successfulFiles;
            });
          }

          // this.$store.dispatch("setLoadding", false);
          // return results;
        })
        .catch((err) => {
          this.$store.dispatch("setLoadding", false);
          console.error(err);
          return [];
        });
      return imgListPromise;
    },

    deleteImgList(file, detail) {
      if (detail && typeof detail.index === "number") {
        this.httpFiles.splice(detail.index, 1);
      }
      return true;
    },

    alipayMch(list) {
      this.filesMch = [];
      this.httpFiles = [];
      this.alipayMchDialog = true;
      this.currentData = JSON.parse(JSON.stringify(list));
    },

    reutrnShowAddMch(data) {
      if (
        (this.$store.state.selfData.m_id == 60007 ||
          this.$store.state.selfData.m_id == 60002) &&
        data.bank_name == "支付宝经营码"
      ) {
        return true;
      }
    },

    isValidAlipayAccount(account1) {
      if (!account1) return false;
      let account = account1.trim();

      // 以 1 开头的 11 位手机号码
      const phonePattern = /^1\d{10}$/;

      // 支持国际电话号码格式
      const internationalPhonePattern = /^\+?[0-9]{1,4}[\s-]?[0-9]{6,15}$/;

      // 电子邮件格式
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      // 支付宝帐号ID，以 2088 开头，后面是 12 位数字
      const alipayIdPattern = /^2088\d{12}$/;

      const alipayCustomIdPattern = /^[a-zA-Z0-9]{6,30}$/;
      let m_id = this.$store.state.selfData.m_id;
      if (m_id == 116770 || m_id == 60002) {
        // 116770 海旺
        if (
          account.indexOf("@hotmail.com") != -1 ||
          account.indexOf("@outlook.com") != -1
        ) {
          return false;
        }
      }
      if (m_id == 61929) return true; // 海濤
      if (m_id == 155586) return true; //星空支付
      return (
        phonePattern.test(account) ||
        internationalPhonePattern.test(account) ||
        emailPattern.test(account) ||
        alipayIdPattern.test(account) ||
        alipayCustomIdPattern.test(account)
      );
    },

    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },

    getUID() {
      window.open(
        `alipays://platformapi/startapp?appId=20000067&url=https%3A%2F%2Frender.alipay.com%2Fp%2Ff%2Ffd-ixpo7iia%2Findex.html`
      );
    },

    getAliCookie() {
      this.addBankData = {
        ...this.addBankData,
        alipay_userid: this.$cookie.get("user_id"),
      };
      this.currentAliBankNo = this.$cookie.get("user_name");
      this.currentAliBankB = this.$cookie.get("mobile");
    },

    clearnAlipay() {
      this.$cookie.delete("user_id");
      this.$cookie.delete("user_name");
      this.$cookie.delete("mobile");
      delete this.addBankData.alipay_userid;
    },

    isLoginAl() {
      if (this.$cookie.get("user_id")) return true;
      return false;
    },

    showAliLogin() {
      return (
        this.addBankData.bank_name &&
        this.addBankData.bank_name.indexOf("支付宝") != -1 &&
        (this.$store.state.selfData.m_id == 60007 ||
          this.$store.state.selfData.m_id == 60002) &&
        this.addBankData.bank_name != "支付宝经营码"
      );
    },

    loginAlipay() {
      let vm = this;
      try {
        let llog = window.open(
          `https://alipaylogin-750237670685.asia-east2.run.app/start-monitor?parentOrigin=${location.origin}`,
          "_blank",
          "width=800,height=600"
        );
        window.addEventListener("message", function (event) {
          if (
            event.origin ===
            "https://alipaylogin-750237670685.asia-east2.run.app"
          ) {
            console.log("Received data from new window: ", event.data);
            if (event.data.data.outUserNo) {
              vm.$cookie.set("user_id", event.data.data.outUserNo);
            } else {
              vm.$cookie.set("user_id", event.data.data.userId);
              vm.$cookie.set("user_name", event.data.data.userName);
              vm.$cookie.set("mobile", event.data.data.mobile);
            }
            llog.close();
          }
        });
      } catch (e) {
        console.error("Unable to access the window: ", e);
      }
    },

    // 数字人民币
    returnName(name) {
      if (name == "支付宝" || name == "微信") {
        return "收款账号";
      }
      if (name == "数字人民币") {
        return "钱包编号";
      }
      return "银行卡号";
    },

    async chechWechatColor(imageFile) {
      return new Promise((resolve) => {
        const vm = this;
        const file = imageFile;
        let check = true;
        if (file && file.type.startsWith("image")) {
          const reader = new FileReader();
          reader.onload = function (e) {
            const img = new Image();
            img.onload = function () {
              const canvas = document.createElement("canvas");
              const ctx = canvas.getContext("2d");
              canvas.width = img.width;
              canvas.height = img.height;
              ctx.drawImage(img, 0, 0);

              const points = [
                { x: 0, y: 0 },
                { x: img.width - 1, y: 0 },
              ];
              for (const point of points) {
                const imageData = ctx.getImageData(point.x, point.y, 1, 1);
                const pixel = imageData.data;
                if (
                  !(
                    (pixel[0] >= -20 &&
                      pixel[0] <= 30 &&
                      pixel[1] >= 168 &&
                      pixel[1] <= 218 &&
                      pixel[2] >= 71 &&
                      pixel[2] <= 121) ||
                    (pixel[0] >= 222 &&
                      pixel[0] <= 262 &&
                      pixel[1] >= 235 &&
                      pixel[1] <= 275 &&
                      pixel[2] >= 221 &&
                      pixel[2] <= 261 &&
                      pixel[3] >= 235 &&
                      pixel[3] <= 275) ||
                    (pixel[0] >= -13 &&
                      pixel[0] <= 27 &&
                      pixel[1] >= -20 &&
                      pixel[1] <= 20 &&
                      pixel[2] >= -20 &&
                      pixel[2] <= 20 &&
                      pixel[3] >= 235 &&
                      pixel[3] <= 275)
                  )
                ) {
                  vm.$toast.fail("请选择正确二维码(1)");
                  resolve(false);
                  return;
                }
              }

              if (check) {
                resolve(true);
              }
            };
            img.src = e.target.result;
            img.crossOrigin = "Anonymous";
          };
          reader.readAsDataURL(file);
        }
      });
    },

    async decodeQRCode3(file) {
      return new Promise((resolve, reject) => {
        const img = document.createElement("img");
        img.src = URL.createObjectURL(file);

        img.onload = async () => {
          const codeReader = new BrowserQRCodeReader();
          try {
            const result = await codeReader.decodeFromImageElement(img);
            resolve(result.getText());
          } catch (err) {
            this.$toast.fail("请选择正确二维码d3");
            reject(false);
            return;
          }
        };

        img.onerror = (err) => {
          this.$toast.fail("图片加载失败");
          reject(err);
        };
      });
    },

    async decodeQRCode2(imageFile) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const imageData = event.target.result;
          const qr = new QrCode();
          qr.callback = (err, value) => {
            if (err) {
              console.log(err, "eeeed2");
              resolve(false);
              return;
            }
            resolve(value.result);
          };
          qr.decode(imageData);
        };
        reader.readAsDataURL(imageFile);
      });
    },

    async decodeQRCode(imageFile) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(imageFile);
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0, img.width, img.height);
          const imageData = ctx.getImageData(0, 0, img.width, img.height);

          const result = jsQR(
            imageData.data,
            imageData.width,
            imageData.height
          );
          if (result) {
            resolve(result.data);
          } else {
            console.log("err", "eeeed23");
            resolve(false);
          }
        };

        img.onerror = (error) => {
          reject(error);
        };
      });
    },

    async beforeUploadAli(imageFile) {
      if (this.$store.state.selfData.not_verify_items?.card_upload == 1) {
        return imageFile;
      }
      if (this.$store.state.selfData.m_id == 82926) {
        return imageFile;
      }
      if (this.$store.state.selfData.m_id == 155586) {
        return imageFile;
      }

      let check = true;
      if (
        this.addBankData.bank_name == "微信" &&
        (this.$store.state.selfData.m_id == 60007 ||
          this.$store.state.selfData.m_id == 60002)
      ) {
        const result = true;
        check = result;
        check = true;
      }
      if (!check) {
        setTimeout(() => {
          this.files = [];
        }, 500);
        return false;
      }

      let qrcodeContent = await this.decodeQRCode(imageFile);
      if (!qrcodeContent) qrcodeContent = await this.decodeQRCode2(imageFile);
      if (!qrcodeContent) qrcodeContent = await this.decodeQRCode3(imageFile);

      return new Promise((resolve, reject) => {
        if (!qrcodeContent) {
          this.$toast.fail("请选择正确二维码(3)");
          reject();
          setTimeout(() => {
            this.files = [];
          }, 500);
        }

        if (this.addBankData.bank_name == "微信") {
          if (
            qrcodeContent.indexOf("wxp://") == 0 ||
            qrcodeContent.indexOf("payapp") != -1 ||
            qrcodeContent.indexOf("xyhangye") != -1 ||
            qrcodeContent.indexOf("yiyun") != -1 ||
            qrcodeContent.indexOf("business.yiyun") != -1 ||
            qrcodeContent.indexOf("xm.meng52") != -1 ||
            qrcodeContent.indexOf("q.lakala") != -1 ||
            qrcodeContent.indexOf("pay.huisaoxinxi") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("p.anxiaostore") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("wechatpay") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("mf.jlpay") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("eycard.cn") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("mchback") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("yhuser") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("alipay.com") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("lililex") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("mq.hkrt") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("fp.aipgd") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("q.jxnxs") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("eqishou") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("jfyh5") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("syb") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("epay") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("jftpay") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("alwaywinpay") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("syt") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("alipays") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("yhyser") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("95516") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("useryh") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("shengpay") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("qr.95516") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("pay.") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("mobile.abc") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("ysepay") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("duolabao") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("hb96568") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("fintechabchina") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("superpaypor") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("jipay") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("lcsw") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("wzcke") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("yyfweb") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("plus") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("shouqianba") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("leshuazf") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("merchant") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("ds.alipay") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("cloudpnr") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("zhifu") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("nongxinyin") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("payuser") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("hbm1") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("cashier") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("nxt.") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("xgd") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("xuser") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("life") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("apione") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("ourl") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("f2f0") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("ybj") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("map.") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("zhenshangzhushou") !=
              -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("lhsd.") != -1
          ) {
            this.addBankData.bank_no = qrcodeContent;
            resolve(imageFile);
          } else {
            this.$toast.fail("请选择正确二维码(2)");
            reject();
          }
        }

        if (this.addBankData.bank_name.indexOf("支付宝") != -1) {
          if (qrcodeContent.toLocaleLowerCase().indexOf("alipay.com") != -1) {
            resolve(imageFile);
            this.isAliQrcode = true;
            console.log("222");
          } else {
            this.isAliQrcode = false;
          }

          if (
            qrcodeContent
              .toLocaleLowerCase()
              .indexOf("https://qr.alipay.com") == 0 ||
            qrcodeContent
              .toLocaleLowerCase()
              .indexOf("https://cloudpay.maycpay.com") == 0 ||
            qrcodeContent.toLocaleLowerCase().indexOf("xpay") != -1 ||
            qrcodeContent.indexOf("yiyun") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("zkeduo") != -1 ||
            qrcodeContent.indexOf("xyhangye") != -1 ||
            qrcodeContent.indexOf("xm.meng52") != -1 ||
            qrcodeContent.indexOf("q.lakala") != -1 ||
            qrcodeContent.indexOf("payapp") != -1 ||
            qrcodeContent.indexOf("business.yiyun") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("p.anxiaostore") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("mf.jlpay") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("lhsd.") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("eycard.cn") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("mchback") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("yhuser") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("alipay.com") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("lililex") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("fp.aipgd") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("q.jxnxs") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("mq.hkrt") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("jfyh5") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("eqishou") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("syb") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("jftpay") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("epay") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("alwaywinpay") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("syt") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("yhyser") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("95516") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("useryh") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("shengpay") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("alipays") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("alipays") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("pay.") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("mobile.abc") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("ysepay") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("duolabao") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("wechatpay") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("hb96568") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("fintechabchina") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("superpaypor") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("jipay") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("lcsw") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("wzcke") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("yyfweb") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("plus") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("shouqianba") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("leshuazf") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("merchant") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("ds.alipay") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("cloudpnr") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("zhifu") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("nongxinyin") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("payuser") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("hbm1") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("cashier") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("nxt.") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("xgd") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("xuser") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("life") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("apione") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("ourl") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("f2f0") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("ybj") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("map.") != -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("zhenshangzhushou") !=
              -1 ||
            qrcodeContent.toLocaleLowerCase().indexOf("qr.95516") != -1 ||
            this.$store.state.selfData.m_id != 60007
          ) {
            resolve(imageFile);
          } else {
            this.$toast.fail("请选择正确二维码(2)");
            reject();
          }
        }
      });
    },

    beforeUpload(files) {
      this.$store.dispatch("setLoadding", true);
      let allFile = [];
      if (!Array.isArray(files)) {
        allFile = [files];
      } else {
        allFile = files;
      }
      return Promise.all(
        allFile.map((file) => {
          if (file.type.indexOf("video") != -1) {
            this.$store.dispatch("setLoadding", false);
            return file;
          }
          return new Promise((resolve, reject) => {
            imageConversion
              .compressAccurately(file, 1000)
              .then((res) => {
                resolve(res);
                this.$store.dispatch("setLoadding", false);
              })
              .catch((err) => {
                this.$toast.fail("请检查文件格式");
                this.$store.dispatch("setLoadding", false);
                reject(err);
              });
          });
        })
      );
    },

    returnBankNameTitle(name) {
      if (name.indexOf("支付宝") != -1) {
        return "支付宝账号";
      }
      if (name == "抖音红包") {
        return "抖音号";
      }
      if (name == "数字人民币") {
        return "钱包编号";
      }
      return "银行卡号";
    },

    addDouyin() {
      this.files = [];
      this.addDouyinModal = true;
      this.addBankData = { type: 0, bank_name: "抖音红包", is_pay: 0 };
    },

    addDigital() {
      this.files = [];
      this.addDigitalyModal = true;
      this.addBankData = { type: 0, bank_name: "数字人民币", is_pay: 0 };
    },

    addAlipay() {
      this.addAlipayModal = true;
      this.clearnAlipay();
      this.files = [];
      this.addBankData = { type: 0, bank_name: "支付宝", is_pay: 0 };
    },

    addPay() {
      this.addBankData = { type: 0, is_pay: 1 };
      this.addBankModal = true;
    },

    addBank() {
      this.files = [];
      this.clearnAlipay();
      if (this.$store.state.selfData.is_alipay) {
        this.addAlipayModal = true;
        this.addBankData = { type: 0, bank_name: "支付宝" };
      } else {
        this.addBankModal = true;
        this.addBankData = { type: 0 };
      }
    },

    delBank(list) {
      this.currentData = JSON.parse(JSON.stringify(list));
      this.delBankModal = true;
    },

    onConfirm(value) {
      this.addBankData.bank_name = value;
      this.bankSelect = false;
    },

    editBank(list) {
      this.currentData = JSON.parse(JSON.stringify(list));
      this.editBankModal = true;
    },

    changeIsC(list) {
      let currentData = JSON.parse(JSON.stringify(list));
      if (currentData.enable == 2) delete currentData.enable;
      this.$dialog
        .confirm({
          title: "提醒",
          message: `是否${list.is_collection == "1" ? "关闭" : "开启"}收款卡？`,
        })
        .then(() => {
          currentData.is_collection = list.is_collection == "1" ? 0 : 1;
          this.$http
            .put(`/mobile/bankCard/${list.id}`, {
              is_collection: currentData.is_collection,
              bank_no: currentData.bank_no,
            })
            .then((res) => {
              if (res.data.code == 0) {
                list.is_collection == "1"
                  ? (list.is_collection = 0)
                  : (list.is_collection = 1);
              }
            });
        });
    },

    changeIspay(list) {
      let currentData = JSON.parse(JSON.stringify(list));
      if (currentData.enable == 2) delete currentData.enable;
      this.$dialog
        .confirm({
          title: "提醒",
          message: `是否${list.is_pay == "1" ? "关闭" : "开启"}出款卡？`,
        })
        .then(() => {
          currentData.is_pay = list.is_pay == "1" ? 0 : 1;
          this.$http
            .put(`/mobile/bankCard/${list.id}`, {
              is_pay: currentData.is_pay,
              bank_no: currentData.bank_no,
            })
            .then((res) => {
              if (res.data.code == 0) {
                list.is_pay == "1" ? (list.is_pay = 0) : (list.is_pay = 1);
              }
            });
        });
    },

    changeEnable(list) {
      let currentData = JSON.parse(JSON.stringify(list));
      this.$dialog
        .confirm({
          title: "提醒",
          message: `是否${list.enable == "1" ? "关闭" : "开启"}账户？`,
        })
        .then(() => {
          currentData.enable = list.enable == "1" ? 0 : 1;
          this.$http
            .put(`/mobile/bankCard/${list.id}`, {
              enable: currentData.enable,
              bank_no: currentData.bank_no,
            })
            .then((res) => {
              if (res.data.code == 0) {
                list.enable == "1" ? (list.enable = 0) : (list.enable = 1);
              }
            });
        });
    },

    getBank() {
      this.$http
        .get(`/mobile/bankCard?type=0&page=${this.currentPage}&paginate=1`)
        .then((res) => {
          if (res.data.code == 0) {
            this.wait = false;
            this.next_page = res.data.next_page;
            let listData = JSON.parse(JSON.stringify(this.bankList));
            if (this.currentPage == 1) {
              listData = [];
            }
            res.data.data.forEach((data) => {
              let have = false;
              listData.forEach((e) => {
                if (e.id == data.id) {
                  have = true;
                }
              });
              if (!have) {
                listData.push(data);
              }
            });
            this.bankList = listData;
          }
        });
    },

    delBankBefore(method, done) {
      if (method == "confirm") {
        this.$http
          .delete(`/mobile/bankCard/${this.currentData.id}`)
          .then((res) => {
            if (res.data.code == 0) {
              this.getBank();
              this.delBankModal = false;
              Toast.success("成功");
            }
          });
      } else {
        done();
      }
      done();
    },

    async addDouyinBankBefore(method, done) {
      let vm = this;
      if (method == "confirm") {
        let fil = false;
        if (this.addBankData.bank_name == "支付宝") {
          const invalidPattern = /\.{2,}|\.$/;

          if (this.addBankData.bank_no) {
            if (
              invalidPattern.test(this.addBankData.bank_no) ||
              !this.isValidAlipayAccount(this.addBankData.bank_no)
            ) {
              this.$toast.fail("请输入正确卡号");
              fil = true;
              return;
            }
          }

          let filtStr = [
            "不过",
            "中断",
            "二维码",
            "去掉",
            "可以",
            "后果",
            "后边",
            "后面",
            "否则",
            "复制",
            "好付",
            "字母",
            "尽量",
            "手机",
            "手机号码",
            "扫码",
            "批量",
            "换着",
            "数字",
            "最后",
            "未收到",
            "申请",
            "直接",
            "确认",
            "自负",
            "请再试",
            "谢谢",
            "转帐",
            "转账",
            "返回",
            "邮箱",
            "重新",
            "限额",
            "风控",
            "默认",
          ];

          const filtPattern = new RegExp(filtStr.join("|"), "g");

          if (this.addBankData.bank_branch) {
            const invalidPattern = /[^\u4e00-\u9fa5a-zA-Z0-9\s]/;
            if (
              invalidPattern.test(this.addBankData.bank_branch) ||
              filtPattern.test(this.addBankData.bank_branch)
            ) {
              this.$toast.fail("请输入正确信息");
              done(false);
              fil = true;
              return;
            }
          }

          if (this.addBankData.bank_owner) {
            const invalidPattern = /[^\u4e00-\u9fa5a-zA-Z0-9\s]/;
            if (
              invalidPattern.test(this.addBankData.bank_owner) ||
              filtPattern.test(this.addBankData.bank_owner)
            ) {
              this.$toast.fail("请输入正确信息");
              done(false);
              fil = true;
              return;
            }
          }
        }

        if (fil) {
          done(false);
          return;
        }

        try {
          this.addBankData.bank_no = this.addBankData.bank_no.trim();
        } catch {
          console.log("err");
        }

        if (!this.addBankData.bank_no) {
          Toast.fail("请输入银行卡号");
          done(false);
          return;
        }

        if (!this.addBankData.bank_name) {
          Toast.fail("请输入开户银行");
          done(false);
          return;
        }

        if (!this.addBankData.bank_owner) {
          Toast.fail("请输入姓名");
          done(false);
          return;
        }

        if (!this.addBankData.ds_limit) {
          Toast.fail("请输入每日限额");
          done(false);
          return;
        }

        var formData = new FormData();
        Object.keys(this.addBankData).forEach((e) => {
          formData.append(e, this.addBankData[e]);
        });

        await this.files.forEach((e, index) => {
          this.$store.dispatch("setLoadding", true);
          const rawFile = this.getUploadRawFile(e);
          if (rawFile) {
            formData.append(
              "files[]",
              rawFile,
              rawFile.name || `upload-${index}.jpg`
            );
          }
          if (index == this.files.length - 1) {
            this.$http.post(`/mobile/bankCard`, formData, {}).then((res) => {
              if (res.data.code == 0) {
                vm.addDouyinModal = false;
                vm.addAlipayModal = false;
                vm.getBank();
                Toast.success("成功");
              } else {
                alert(res.data.message);
              }
            });
          }
        });

        if (!this.files.length) {
          this.$http.post(`/mobile/bankCard`, formData, {}).then((res) => {
            if (res.data.code == 0) {
              vm.addDouyinModal = false;
              vm.getBank();
              Toast.success("成功");
            } else {
              alert(res.data.message);
            }
          });
        }

        done(false);
      } else {
        done();
        return;
      }
    },

    async addDigitalyBefore(method, done) {
      let vm = this;
      if (method == "confirm") {
        let fil = false;
        if (this.addBankData.bank_name == "支付宝") {
          const invalidPattern = /\.{2,}|\.$/;

          if (this.addBankData.bank_no) {
            if (
              invalidPattern.test(this.addBankData.bank_no) ||
              !this.isValidAlipayAccount(this.addBankData.bank_no)
            ) {
              this.$toast.fail("请输入正确卡号");
              done(false);
              fil = true;
              return;
            }
          }

          let filtStr = [
            "不过",
            "中断",
            "二维码",
            "去掉",
            "可以",
            "后果",
            "后边",
            "后面",
            "否则",
            "复制",
            "好付",
            "字母",
            "尽量",
            "手机",
            "手机号码",
            "扫码",
            "批量",
            "换着",
            "数字",
            "最后",
            "未收到",
            "申请",
            "直接",
            "确认",
            "自负",
            "请再试",
            "谢谢",
            "转帐",
            "转账",
            "返回",
            "邮箱",
            "重新",
            "限额",
            "风控",
            "默认",
          ];

          const filtPattern = new RegExp(filtStr.join("|"), "g");

          if (this.addBankData.bank_branch) {
            const invalidPattern = /[^\u4e00-\u9fa5a-zA-Z0-9\s]/;
            if (
              invalidPattern.test(this.addBankData.bank_branch) ||
              filtPattern.test(this.addBankData.bank_branch)
            ) {
              this.$toast.fail("请输入正确信息");
              done(false);
              fil = true;
              return;
            }
          }

          if (this.addBankData.bank_owner) {
            const invalidPattern = /[^\u4e00-\u9fa5a-zA-Z0-9\s]/;
            if (
              invalidPattern.test(this.addBankData.bank_owner) ||
              filtPattern.test(this.addBankData.bank_owner)
            ) {
              this.$toast.fail("请输入正确信息");
              done(false);
              fil = true;
              return;
            }
          }
        }

        if (fil) {
          done(false);
          return;
        }

        try {
          this.addBankData.bank_no = this.addBankData.bank_no.trim();
        } catch {
          console.log("err");
        }

        if (!this.addBankData.bank_no) {
          Toast.fail("请输入银行卡号");
          done(false);
          return;
        }

        if (!this.addBankData.bank_owner) {
          Toast.fail("请输入姓名");
          done(false);
          return;
        }

        if (!this.addBankData.ds_limit) {
          Toast.fail("请输入每日限额");
          done(false);
          return;
        }

        var formData = new FormData();
        Object.keys(this.addBankData).forEach((e) => {
          formData.append(e, this.addBankData[e]);
        });

        await this.files.forEach((e, index) => {
          this.$store.dispatch("setLoadding", true);
          const rawFile = this.getUploadRawFile(e);
          if (rawFile) {
            formData.append(
              "files[]",
              rawFile,
              rawFile.name || `upload-${index}.jpg`
            );
          }
          if (index == this.files.length - 1) {
            this.$http.post(`/mobile/bankCard`, formData, {}).then((res) => {
              if (res.data.code == 0) {
                vm.addBankModal = false;
                vm.addDigitalyModal = false;
                vm.getBank();
                Toast.success("成功");
              } else {
                alert(res.data.message);
              }
            });
          }
        });

        if (!this.files.length) {
          this.$http.post(`/mobile/bankCard`, formData, {}).then((res) => {
            if (res.data.code == 0) {
              vm.addDigitalyModal = false;
              vm.getBank();
              Toast.success("成功");
            } else {
              alert(res.data.message);
            }
          });
        }

        done(false);
      } else {
        done();
        return;
      }
    },

    async addAlipayBankBefore(method, done) {
      let vm = this;
      if (method == "confirm") {
        let fil = false;
        if (this.addBankData.bank_name == "支付宝") {
          const invalidPattern = /\.{2,}|\.$/;

          if (this.addBankData.bank_no) {
            if (
              invalidPattern.test(this.addBankData.bank_no) ||
              !this.isValidAlipayAccount(this.addBankData.bank_no)
            ) {
              this.$toast.fail("请输入正确卡号");
              done(false);
              fil = true;
              return;
            }
          }

          let filtStr = [
            "不过",
            "中断",
            "二维码",
            "去掉",
            "可以",
            "后果",
            "后边",
            "后面",
            "否则",
            "复制",
            "好付",
            "字母",
            "尽量",
            "手机",
            "手机号码",
            "扫码",
            "批量",
            "换着",
            "数字",
            "最后",
            "未收到",
            "申请",
            "直接",
            "确认",
            "自负",
            "请再试",
            "谢谢",
            "转帐",
            "转账",
            "返回",
            "邮箱",
            "重新",
            "限额",
            "风控",
            "默认",
          ];

          const filtPattern = new RegExp(filtStr.join("|"), "g");

          if (this.addBankData.bank_branch) {
            const invalidPattern = /[^\u4e00-\u9fa5a-zA-Z0-9\s]/;
            if (
              invalidPattern.test(this.addBankData.bank_branch) ||
              filtPattern.test(this.addBankData.bank_branch)
            ) {
              this.$toast.fail("请输入正确信息");
              done(false);
              fil = true;
              return;
            }
          }

          if (this.addBankData.bank_owner) {
            const invalidPattern = /[^\u4e00-\u9fa5a-zA-Z0-9\s]/;
            if (
              invalidPattern.test(this.addBankData.bank_owner) ||
              filtPattern.test(this.addBankData.bank_owner)
            ) {
              this.$toast.fail("请输入正确信息");
              done(false);
              fil = true;
              return;
            }
          }
        }

        if (fil) {
          done(false);
          return;
        }

        try {
          this.addBankData.bank_no = this.addBankData.bank_no.trim();
        } catch {
          console.log("err");
        }

        if (!this.addBankData.bank_no) {
          Toast.fail("请输入银行卡号");
          done(false);
          return;
        }

        if (!this.addBankData.bank_branch) {
          Toast.fail("请输入真实姓名");
          done(false);
          return;
        }

        if (!this.addBankData.bank_name) {
          Toast.fail("请输入开户银行");
          done(false);
          return;
        }

        if (!this.addBankData.bank_owner) {
          Toast.fail("请输入昵称");
          done(false);
          return;
        }

        if (!this.addBankData.ds_limit) {
          Toast.fail("请输入每日限额");
          done(false);
          return;
        }

        if (
          this.showAliLogin() &&
          this.addBankData.bank_name.indexOf("222支付宝") != -1 &&
          !this.isAliQrcode &&
          !this.addBankData.alipay_userid
        ) {
          done(false);
          Toast.fail("请输入支付宝UID");
          return;
        } else {
          if (this.addBankData.alipay_userid) {
            this.addBankData.alipay_userid =
              this.addBankData.alipay_userid.replace(/\s+/g, "");
          }
        }

        var formData = new FormData();
        Object.keys(this.addBankData).forEach((e) => {
          formData.append(e, this.addBankData[e]);
        });

        if (
          this.$store.state.selfData.m_id == 155586 ||
          this.$store.state.selfData.m_id == 60002
        ) {
          const response = await fetch("/arrow.png");
          const blob = await response.blob();
          const file = new File([blob], "test.png", { type: blob.type });

          formData.append("files[]", file);
          this.$http.post(`/mobile/bankCard`, formData, {}).then((res) => {
            if (res.data.code == 0) {
              vm.addBankModal = false;
              vm.addAlipayModal = false;
              vm.getBank();
              Toast.success("成功");
            } else {
              alert(res.data.message);
            }
          });
        } else {
          await this.files.forEach((e, index) => {
            this.$store.dispatch("setLoadding", true);
            const rawFile = this.getUploadRawFile(e);
            if (rawFile) {
              formData.append(
                "files[]",
                rawFile,
                rawFile.name || `upload-${index}.jpg`
              );
            }
            if (index == this.files.length - 1) {
              this.$http.post(`/mobile/bankCard`, formData, {}).then((res) => {
                if (res.data.code == 0) {
                  vm.addBankModal = false;
                  vm.addAlipayModal = false;
                  vm.getBank();
                  Toast.success("成功");
                } else {
                  alert(res.data.message);
                }
              });
            }
          });

          if (!this.files.length) {
            this.$http.post(`/mobile/bankCard`, formData, {}).then((res) => {
              if (res.data.code == 0) {
                vm.addAlipayModal = false;
                vm.getBank();
                Toast.success("成功");
              } else {
                alert(res.data.message);
              }
            });
          }
        }

        done(false);
      } else {
        done();
        return;
      }
    },

    compareWithWildcard(bank_no, mobile) {
      const regex = new RegExp(mobile.replace(/\*/g, ".*"));
      return regex.test(bank_no);
    },

    async addBankBefore(method, done) {
      let vm = this;
      if (method == "confirm") {
        console.log(!this.isValidAlipayAccount(this.addBankData.bank_no));
        let fil = false;

        if (this.addBankData.bank_name == "支付宝") {
          const invalidPattern = /\.{2,}|\.$/;

          if (this.addBankData.bank_no) {
            if (
              invalidPattern.test(this.addBankData.bank_no) ||
              !this.isValidAlipayAccount(this.addBankData.bank_no)
            ) {
              this.$toast.fail("请输入正确卡号");
              done(false);
              fil = true;
              return;
            }
          }

          let filtStr = [
            "不过",
            "中断",
            "二维码",
            "去掉",
            "可以",
            "后果",
            "后边",
            "后面",
            "否则",
            "复制",
            "好付",
            "字母",
            "尽量",
            "手机",
            "手机号码",
            "扫码",
            "批量",
            "换着",
            "数字",
            "最后",
            "未收到",
            "申请",
            "直接",
            "确认",
            "自负",
            "请再试",
            "谢谢",
            "转帐",
            "转账",
            "返回",
            "邮箱",
            "重新",
            "限额",
            "风控",
            "默认",
          ];

          const filtPattern = new RegExp(filtStr.join("|"), "g");

          if (this.addBankData.bank_branch) {
            const invalidPattern = /[^\u4e00-\u9fa5a-zA-Z0-9\s]/;
            if (
              invalidPattern.test(this.addBankData.bank_branch) ||
              filtPattern.test(this.addBankData.bank_branch)
            ) {
              this.$toast.fail("请输入正确信息");
              done(false);
              fil = true;
              return;
            }
          }

          if (this.addBankData.bank_owner) {
            const invalidPattern = /[^\u4e00-\u9fa5a-zA-Z0-9\s]/;
            if (
              invalidPattern.test(this.addBankData.bank_owner) ||
              filtPattern.test(this.addBankData.bank_owner)
            ) {
              this.$toast.fail("请输入正确信息");
              done(false);
              fil = true;
              return;
            }
          }
        }

        if (fil) {
          done(false);
          return;
        }

        try {
          this.addBankData.bank_no = this.addBankData.bank_no.trim();
        } catch {
          console.log("err");
        }

        if (!this.addBankData.bank_no) {
          Toast.fail("请输入银行卡号");
          done(false);
          return;
        }

        if (
          this.showAliLogin() &&
          this.addBankData.bank_name.indexOf("222支付宝") != -1 &&
          !this.isAliQrcode &&
          !this.addBankData.alipay_userid
        ) {
          done(false);
          Toast.fail("请输入支付宝UID");
          return;
        } else {
          if (this.addBankData.alipay_userid) {
            this.addBankData.alipay_userid =
              this.addBankData.alipay_userid.replace(/\s+/g, "");
          }
        }

        if (
          !this.addBankData.bank_branch &&
          this.addBankData.bank_name != "数字人民币" &&
          this.addBankData.bank_name != "微信"
        ) {
          Toast.fail("请输入支行名称");
          done(false);
          return;
        }

        if (!this.addBankData.bank_name) {
          Toast.fail("请输入开户银行");
          done(false);
          return;
        }

        if (!this.addBankData.bank_owner) {
          Toast.fail("请输入姓名");
          done(false);
          return;
        }

        if (!this.addBankData.ds_limit) {
          Toast.fail("请输入每日限额");
          done(false);
          return;
        }

        if (!this.addBankData.alipay_userid)
          delete this.addBankData.alipay_userid;

        var formData = new FormData();

        Object.keys(this.addBankData).forEach((e) => {
          formData.append(e, this.addBankData[e]);
        });

        if (
          this.$store.state.selfData.m_id == 155586 ||
          this.$store.state.selfData.m_id == 60002
        ) {
          const response = await fetch("/arrow.png");
          const blob = await response.blob();
          const file = new File([blob], "test.png", { type: blob.type });

          formData.append("files[]", file);
        } else {
          if (this.addBankData.bank_name != "微信") {
            this.files.forEach((e, index) => {
              const rawFile = this.getUploadRawFile(e);
              if (rawFile) {
                formData.append(
                  "files[]",
                  rawFile,
                  rawFile.name || `upload-${index}.jpg`
                );
              }
            });
          }
        }

        this.$http.post(`/mobile/bankCard`, formData, {}).then((res) => {
          if (res.data.code == 0) {
            vm.addBankModal = false;
            vm.getBank();
            Toast.success("成功");
          } else {
            alert(res.data.message);
          }
        });

        done(false);
      } else {
        done();
        return;
      }
    },

    editBankBefore(method, done) {
      if (method == "confirm") {
        this.editBankModal = true;
        let data = JSON.parse(JSON.stringify(this.currentData));
        delete data.enable;
        this.$http
          .put(`/mobile/bankCard/${this.currentData.id}`, {
            ds_limit: data.ds_limit,
            bank_no: data.bank_no,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.bankList.forEach((e, index) => {
                if (e.id == this.currentData.id) {
                  this.bankList[index].ds_limit = this.currentData.ds_limit;
                }
              });
              this.editBankModal = false;
              Toast.success("成功");
            }
          });
        done(false);
      } else {
        done();
        return;
      }
    },

    onClickLeft() {
      this.$router.push(this.$cookie.get("prevPage") || "/");
    },

    scrollPage() {
      if (window.scrollY + window.screen.height >= document.body.scrollHeight) {
        if (this.next_page) {
          if (this.wait) return;
          this.wait = true;
          this.currentPage += 1;
          this.getBank();
        }
      }
    },
  },

  created() {
    this.getBank();
    this.$http.get(`/mobile/banks`).then((res) => {
      this.banks = res.data.data;
    });

    // this.getCT = setInterval(() => {
    //   this.getAliCookie();
    // }, 2000);
  },

  mounted() {
    window.addEventListener("scroll", this.scrollPage);
  },

  destroyed() {
    clearInterval(this.getCT);
    window.removeEventListener("scroll", this.scrollPage);
  },

  computed: {
    ...mapState([
      "showOverlay",
      // ...
    ]),
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  // background-image: url("/home-page_bg.png");
  // background-position: center center;
  background-size: 100%;
  background-repeat: no-repeat;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tableWrap {
  display: flex;
  flex-wrap: wrap;
  background-color: #fff;
  width: 355px;
  padding: 10px 20px;
  padding-bottom: 0px;
  border-radius: 10px;
  margin-bottom: 15px;

  .tableContent {
    width: 100%;
    display: flex;
    font-size: 14px;
    height: 25px;
    align-items: center;

    .tableTitle {
      font-weight: 400;
      white-space: nowrap;
      width: 60px;
      text-align: left;
      margin-right: 10px;
    }

    .tablesContent {
      color: #999999;
      word-break: break-all;
    }
  }
}

.addAcc {
  display: flex;
  align-items: center;
  // color: #009aaa;
  font-size: 14px;

  .plus {
    color: #009aaa !important;
    font-weight: bold;
    font-size: 14px;
    margin-right: 5px;
    //
  }
}

.editBtn {
  height: 45px;
  text-align: center;
  // color: #009aaa;
  width: 100%;
  display: flex;

  p {
    width: 50%;
    line-height: 45px;
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
